import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

export function StyledMarkdown({ markdown }: { markdown: string | undefined }) {
  return (
    <Markdown
      // remark-gfm adds strikethrough (~~...~~), tables and autolinks; rehype-raw
      // renders inline HTML the Strapi rich-text editor emits (e.g. <u>...</u>).
      // Strapi content is authored by trusted internal editors.
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        li({ children }) {
          return <li className="ml-6 list-disc">{children}</li>;
        },
        ul({ children }) {
          return <ul className="mb-2">{children}</ul>;
        },
        p({ children }) {
          return <p className="leading-normal mb-1">{children}</p>;
        },
      }}
    >
      {markdown}
    </Markdown>
  );
}
